import React from 'react';

function Portfolio() {
  return (
    <section id="portfolio" aria-labelledby="portfolio">
      <div className="portfolio-content revealable">
        <h2>Featured Certifications</h2>

        <div className="cert-grid">
          <a href="https://www.coursera.org/account/accomplishments/certificate/SRQWK2RN72L8" target="_blank" rel="noopener noreferrer">
            <img src="assets/cert-yale.png" alt="Yale University Certification" />
          </a>

          <a href="https://www.linkedin.com/in/alamoudison/details/certifications/1723136005404/single-media-viewer/?profileId=ACoAAA2hsIoB28VIWnb4GJ2hOH7DSUB1SW9Yj-U" target="_blank" rel="noopener noreferrer">
            <img src="assets/cert-bloomberg.png" alt="Bloomberg Market Concepts Certification" />
          </a>

          <a href="https://www.coursera.org/account/accomplishments/specialization/certificate/GY2S66BX3NBL" target="_blank" rel="noopener noreferrer">
            <img src="assets/cert-rice.png" alt="Rice University Investment & Portfolio Management Certification" />
          </a>

          <a href="https://www.coursera.org/account/accomplishments/specialization/certificate/V9U4K5CW4HQQ" 
             target="_blank" 
             rel="noopener noreferrer">
            <img src="assets/cert-pwc.png" alt="PwC Financial Analysis Specialization Certification" />
          </a>
                    <a href="https://www.linkedin.com/in/alamoudison/overlay/Certifications/344456995/treasury/?profileId=ACoAAA2hsIoB28VIWnb4GJ2hOH7DSUB1SW9Yj-U" 
             target="_blank" 
             rel="noopener noreferrer">
            <img src="assets/cert-taqeem.png" alt="Regulatory Framework for Valuation Profession and International Valuation Standards, 
Module 001, Saudi Authority for Accredited Valuers (TAQEEM) Certification" />
          </a>
        </div>

        <p className="additional-note">
          Additional professional certifications available upon request.
        </p>

        <button className="btn-secondary">
          <a href="assets/certifications.pdf" download>View All Certifications</a>
        </button>
      </div>
    </section>
  );
}

export default Portfolio;